import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useSubscription } from "@/contexts/SubscriptionContext";
import { Button } from "./ui/button";
import { Card } from "./ui/card";
import { Sparkles, Clock } from "lucide-react";

export const SubscriptionBanner = memo(function SubscriptionBanner() {
  const { t } = useTranslation();
  const { subscribed, isTrialActive, trialDaysRemaining, createCheckout, loading, trialEnd } = useSubscription();

  if (loading || subscribed) return null;

  // Active trial phase
  if (isTrialActive && trialDaysRemaining > 0) {
    return (
      <Card className="mb-6 border-2 border-primary/20 bg-gradient-to-r from-primary/5 to-accent/5">
        <div className="p-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
              <Clock className="w-6 h-6 text-primary" />
            </div>
            <div>
              <h3 className="font-semibold text-lg">⏰ {t('subscription.trialActive', 'Testphase aktiv')}</h3>
              <p className="text-sm text-muted-foreground">
                {t('subscription.trialRemaining', 'Noch {{days}} {{unit}} unbegrenzter Zugriff auf alle Features', {
                  days: trialDaysRemaining,
                  unit: trialDaysRemaining === 1 ? t('subscription.day', 'Tag') : t('subscription.days', 'Tage')
                })}
              </p>
            </div>
          </div>
          <Button 
            onClick={createCheckout}
            size="lg"
            className="whitespace-nowrap"
          >
            {t('subscription.upgradeNow', 'Jetzt upgraden')}
          </Button>
        </div>
      </Card>
    );
  }

  // Trial expired or new user
  const message = trialEnd
    ? t('subscription.trialExpired', 'Deine Testphase ist abgelaufen · Unbegrenzter Zugriff mit Premium für nur €29/Monat inkl. 5 Tage Testphase bei Neuabschluss')
    : t('subscription.upgradeDescription', 'Sichere dir unbegrenzten Zugriff für nur €29/Monat inkl. 5 Tage kostenloser Testphase');

  return (
    <Card className="mb-6 border-2 border-primary/20 bg-gradient-to-r from-primary/5 to-accent/5">
      <div className="p-6 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
            <Sparkles className="w-6 h-6 text-primary" />
          </div>
          <div>
            <h3 className="font-semibold text-lg">🚀 {t('subscription.upgradeToPremium', 'Upgrade auf Juni Premium')}</h3>
            <p className="text-sm text-muted-foreground">{message}</p>
          </div>
        </div>
        <Button 
          onClick={createCheckout}
          size="lg"
          className="whitespace-nowrap"
        >
          {t('subscription.upgradeNow', 'Jetzt upgraden')}
        </Button>
      </div>
    </Card>
  );
});